import { Box, styled } from '@tino-frontend/coreui'

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.contrastText,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
}))

export const Content = styled(Box)({
  maxWidth: 300,
})

export const Title = styled(Box)({
  fontFamily: 'Universal Sans Text',
  fontWeight: 200,
  fontSize: 32,
  lineHeight: '120%',
  marginBottom: 24,
})
